module.exports = __webpack_public_path__ + "img/banner-titulo.04e70615.png";